enum Characters {
    QUINT = "quint",
    HOOPER = "hooper",
    BRODY = "brody"
}

export default Characters